import { render, staticRenderFns } from "./IconPhoneIncomingOutline.vue?vue&type=template&id=b0fa0f80"
import script from "./IconPhoneIncomingOutline.vue?vue&type=script&lang=js"
export * from "./IconPhoneIncomingOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports